export default "__VITE_ASSET__BTMlfcCb__"